import { initializeApp } from "firebase/app";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCbO6i8ra4cE20ISHyMbXMmjgBTwnGkhNo",
  authDomain: "clone-123c4.firebaseapp.com",
  projectId: "clone-123c4",
  storageBucket: "clone-123c4.appspot.com",
  messagingSenderId: "670126590310",
  appId: "1:670126590310:web:af68f8ef73d6a8816ca0a7",
  measurementId: "G-JX1QTXPDP7",
};

const firebaseApp = initializeApp(firebaseConfig);
const db = getFirestore(firebaseApp);
const auth = getAuth(firebaseApp);

export {
  db,
  auth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
};
